import React from "react";
import {
  LayoutDashboard,
  Send,
  Zap,
  Layers,
  Smartphone,
  BarChart3,
  MessageCircle,
  User,
  Users,
  CreditCard,
  Shield,
  GitBranch
} from "lucide-react";
import { showWhatsappExtraPages, showCampaigns, showContacts , showWorkflows} from "../../utils/featureFlags";

const allWhatsappRoutes = [
  {
    id: 141,
    name: 'Dashboard',
    url: '/whatsapp/dashboard',
    componentName: 'WhatsappDashboard',
    icon: <LayoutDashboard />,
  },
  {
    id: 142,
    name: 'SendMessage',
    navName: 'Send Message',
    url: '/whatsapp/send-message',
    componentName: 'SendMessage',
    icon: <Send />,
  },
  {
    id: 143,
    name: 'Campaigns',
    url: '/whatsapp/campaigns',
    componentName: 'Campaigns',
    icon: <Zap />,
    showIf: () => showCampaigns,
  },
  {
    id: 1430,
    name: 'Contacts',
    url: '/whatsapp/contacts',
    componentName: 'Contacts',
    icon: <Users />,
    showIf: () => showContacts,
  },
  {
    id: 144,
    name: 'Templates',
    url: '/whatsapp/templates',
    componentName: 'Templates',
    icon: <Layers />,
  },
  {
    id: 145,
    name: 'ManageNumbers',
    navName: 'Manage Numbers',
    url: '/whatsapp/manage-numbers',
    componentName: 'ManageNumbers',
    icon: <Smartphone />,
  },
  {
    id: 146,
    name: 'Analytics',
    url: '/whatsapp/analytics',
    componentName: 'Analytics',
    icon: <BarChart3 />,
  },
  {
    id: 147,
    name: 'Chat',
    url: '/whatsapp/chat',
    componentName: 'Chat',
    icon: <MessageCircle />,
  },
  {
    id: 151,
    name: 'WorkFlows',
    url: '/whatsapp/workflows',
    componentName: 'WorkflowsIndex',
    navName: 'WorkFlows',
    icon: <GitBranch />,
    showIf: () => showWorkflows,
  },
  {
    id: 1471,
    name: 'OptInOptOut',
    navName: 'Opt-in/Opt-out',
    url: '/whatsapp/opt-in-opt-out',
    componentName: 'OptInOptOut',
    icon: <User />,
    showIf: () => showWhatsappExtraPages,
  },
  {
    id: 148,
    name: 'Billing',
    url: '/whatsapp/billing',
    componentName: 'Billing',
    icon: <CreditCard />,
  },
  {
    id: 149,
    name: 'AccountHealth',
    navName: 'Account Health',
    url: '/whatsapp/account-health',
    componentName: 'AccountHealth',
    icon: <Shield />,
    showIf: () => showWhatsappExtraPages,
  },
  {
    id: showWhatsappExtraPages ? 150 : 149,
    name: 'Permissions',
    navName: 'Permissions',
    url: '/permissions/index',
    componentName: 'PermissionsIndex',
    icon: <Shield />,
    requiredEntitlement: 'WHATSAPP',
  },
];

const getWhatsappChildren = () => {
  return allWhatsappRoutes.filter(route => !route.showIf || route.showIf());
};

export const whatsappChildren = getWhatsappChildren();
